import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import Step from '@components/PageStep';
import {IReviewsItem, ITranslation} from '@common/types';
import ReviewsGrid from '@components/ReviewsGrid';
import Text from '@common/components/common/Text';
import {useTranslation} from '@common/hooks/useTranslation';

export const Services = () => {
  const t = useTranslation('components') as ITranslation['components'];
  const {servicePage} = useTypedSelector(state => state.services);

  return (
    <>
      <section className="inner-title">
        <div className="container">
          <h1 className="inner-title__text">
            <Text text={servicePage?.title}/>
          </h1>
        </div>
      </section>

      <section className="inner-grid inner-grid--no-padding">
        <div className="container">
          <h2 className="visually-hidden">{t.services.visuallyHidden}</h2>
          <ReviewsGrid
            type="services"
            reviews={servicePage?.services?.map((r) => ({
              slug: r.slug,
              title: r.title,
              description: r.description,
              color: r.color,
              cardType: r.cardType,
              onlyPreview: r?.meta?.onlyPreview
            })) as IReviewsItem[] || []}
          />
        </div>
      </section>

      {servicePage?.steps?.map((item, index) => {
        const classes = !(item.count > 1 || servicePage?.steps.length <= 1) ? [] : ['inner-grid--margin-bottom'];
        return (
          <Step
            key={`step_${index}`}
            count={item.count}
            classNames={classes}
            step={item.step}
            stepChildren={item.children}
          />
        )
      })}
    </>
  )
}
